import { render, staticRenderFns } from "./specialPage33.vue?vue&type=template&id=1efb77dc&scoped=true&"
import script from "./specialPage33.vue?vue&type=script&lang=js&"
export * from "./specialPage33.vue?vue&type=script&lang=js&"
import style0 from "./specialPage33.vue?vue&type=style&index=0&id=1efb77dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb77dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
